import { Close } from "@mui/icons-material";
import { Dialog, DialogTitle, Button } from "@mui/material";
import { Accomplishment } from "../../models/Accomplishment";
import { AccomplishmentStatusFilters } from "../../utils/enums/filters/AccomplishmentStatusFilters";
import OpsDateUtils from "../../utils/OpsDateUtils";
import { DebounceButton } from "../../external/ensolvers-core-frontend-mui/components/Common/DebounceButton";
import { Token } from "../../theme";

interface Props {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  accomplishment: Accomplishment | undefined;
  handleUpdateStatus?: (accomplishment: Accomplishment, status: string) => void;
  hideApproveButton?: boolean;
}

const isValidURL = (string: string): boolean => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};

const AccomplishmentDetailsDialog = ({ isOpen, setIsOpen, accomplishment, handleUpdateStatus, hideApproveButton }: Props) => {
  return (
    <Dialog onClose={() => setIsOpen(false)} open={isOpen}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingRight: "15px",
        }}
      >
        <DialogTitle style={{ color: Token.textPrimary, marginBottom: -20, marginTop: 10 }}>Accomplishment details</DialogTitle>
        <div
          onClick={() => {
            setIsOpen(false);
          }}
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        >
          <Close />
        </div>
      </div>
      <div style={{ padding: "15px 30px" }}>
        {accomplishment && (
          <>
            <p>
              <b>Reporter:</b> {`${accomplishment.reporter.firstName} ${accomplishment.reporter.lastName}`}
            </p>
            <p>
              <b>Type:</b> {accomplishment.type.title}
            </p>
            <p>
              <b>Created at:</b> {OpsDateUtils.ensureFormatDateUTC(accomplishment.createdAt)}
            </p>
            {accomplishment.info.length > 0 && (
              <p>
                <b>Info:</b>{" "}
                {accomplishment.info.length > 0 &&
                  accomplishment.info.map((a, index) => (
                    <p key={index}>
                      -{" "}
                      {isValidURL(a) ? (
                        <a href={a} target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                          {a}
                        </a>
                      ) : (
                        a
                      )}
                    </p>
                  ))}
              </p>
            )}
            <p>
              <b>Role: </b> {accomplishment.role ? accomplishment.role : "-"}
            </p>
            <p>
              <b>Status: </b> {accomplishment.status}
            </p>
            {accomplishment.status === AccomplishmentStatusFilters.APPROVED && (
              <p>
                <b>Approved: </b> {OpsDateUtils.ensureFormatDateUTC(accomplishment.approvedDate)}
              </p>
            )}
          </>
        )}
        {!hideApproveButton && (
          <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
            <DebounceButton
              variant="contained"
              color="primary"
              onClick={() => {
                handleUpdateStatus(accomplishment!, "Approved");
                setIsOpen(false);
              }}
              style={{
                marginRight: 20,
                color: "white",
                backgroundColor: Token.actionPrimary,
                marginBottom: 10,
                boxShadow: "none",
              }}
              text={"Approve"}
            >
              Approve
            </DebounceButton>
            <DebounceButton
              variant="contained"
              color="secondary"
              onClick={() => {
                handleUpdateStatus(accomplishment!, "Rejected");
                setIsOpen(false);
              }}
              style={{
                backgroundColor: "white",
                color: Token.textSecondary,
                border: `1px solid ${Token.borderDefault}`,
                marginBottom: 10,
                boxShadow: "none",
              }}
              text={"Reject"}
            >
              Reject
            </DebounceButton>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AccomplishmentDetailsDialog;
